import React from 'react';
import {Link, useNavigate} from 'react-router-dom';

const ProductsPage = () => {
  const navigate = useNavigate();
  const backgroundImagePath = 'images/Cabonara.png'; // Path to your background image

  return (
    <div className="relative bg-[#1a1a1a] text-white h-full w-full flex flex-col justify-end">
      <div className="m-auto flex flex-col justify-center items-center text-white p-6 w-full min-h-full h-screen md:w-1/2">
        <div className="px-6 mt-4 flex flex-col font-extrabold">
          <h1 className="text-3xl font-extrabold my-6">Select Product</h1>
        </div>
        <ul className="text-xl text-white z-10 gap-2">
          <Link to="/cook">
            <li>
              <div className="px-6 py-2 mb-4 flex items-center bg-gray-700 hover:bg-gray-800 rounded-lg">
                <div className="image pr-4">
                  <img src='images/BioSpag1.png' className="w-20 h-20" />
                </div>
                <div className="text-sm break-normal">
                  Migro Bio Vollkorn Spaghettini
                  <div className="line2 flex  pt-2">
                    <div className="flex gap-1 pr-2">
                      <div>
                        <img src={'images/Leaf.png'} alt="Image 1" className="w-4 h-4"/>
                      </div>
                      <div>
                        <img src={'images/Migros.png'} alt="Image 2" className="w-4 h-4"/>
                      </div>
                    </div>
                    <div>CHF 2.00</div>
                  </div>
                </div>
              </div>
            </li>
          </Link>
          <li>
            <div className="px-6 mb-4 flex items-center">
              <div className="image pr-4">
                <img src='images/AlnaturaSpag.png' className="w-20 h-20" />
              </div>
              <div className="text-sm">
                Alnatura Vollkorn Spaghetti
                <div className="line2 flex  pt-2">
                  <div className="flex gap-1 pr-2">
                    <div>
                      <img src={'images/Leaf.png'} alt="Image 1" className="w-4 h-4"/>
                    </div>
                    <div>
                      <img src={'images/Migros.png'} alt="Image 2" className="w-4 h-4"/>
                    </div>
                  </div>
                  <div>CHF 3.50</div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="px-6 mb-4 flex items-center">
              <div className="image pr-4">
                <img src='images/GranoSpag.png' className="w-20 h-20" />
              </div>
              <p className="text-sm">
                <div>Molisana Spaghetti Vollkorn</div>
                <div className="line2 flex  pt-2">
                  <div className="flex gap-1 pr-2">
                    <div>
                      <img src={'images/Leaf.png'} alt="Image 1" className="w-4 h-4"/>
                    </div>
                    <div>
                      <img src={'images/Migros.png'} alt="Image 2" className="w-4 h-4"/>
                    </div>
                  </div>
                  <div>CHF 2.10</div>
                </div>
              </p>
            </div>
          </li>
          <li>
            <div className="px-6 mb-4 flex items-center">
              <div className="image pr-4">
                <img src='images/UrDinkel.png' className="w-20 h-20" />
              </div>
              <p className="text-sm">
                <div>Aus der Region Bio Spaghetti 2x 500g</div>
                <div className="line2 flex  pt-2">
                  <div className="flex gap-1 pr-2">
                    <div>
                      <img src={'images/Leaf.png'} alt="Image 1" className="w-4 h-4"/>
                    </div>
                    <div>
                      <img src={'images/Migros.png'} alt="Image 2" className="w-4 h-4"/>
                    </div>
                  </div>
                  <div>CHF 5.90</div>
                </div>
              </p>
            </div>
          </li>
        </ul>
        <div className="flex justify-center md:justify-start pb-2">
          <button
              className="py-2 my-6 md:my-3 bg-orange-600 hover:bg-orange-500 text-white px-8 rounded-full text-lg w-3/4 md:w-64 md:text-xl font-bold"
              onClick={() => {
                navigate('/cook');
              }}
          >
            Ready
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;
